(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["country-domain-switch-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LOG_PREFIX = '[GeoDomainSwitch]';

    function log(level, message, payload) {
      if (typeof console === 'undefined') return;
      if (payload !== undefined) {
        console[level](LOG_PREFIX + ' ' + message, payload);
        return;
      }
      console[level](LOG_PREFIX + ' ' + message);
    }

    function normalizeHost(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '')
        .split('/')[0];
    }

    function getDismissKey(sectionId, rule) {
      return 'geo-domain-switch:' + sectionId + ':' + rule.country + ':' + rule.source_host;
    }

    function getStorage() {
      try {
        return window.sessionStorage;
      } catch (e) {
        return null;
      }
    }

    function run(root, sectionId, visitorCountry, currentHost, testMode) {
      var rulesElement = root.querySelector('[data-geo-rules]');
      var dialog = root.querySelector('.geo-domain-switch__dialog');
      var heading = root.querySelector('[data-geo-heading]');
      var message = root.querySelector('[data-geo-text]');
      var switchLink = root.querySelector('[data-geo-switch-link]');
      var stayButton = root.querySelector('[data-geo-stay]');
      var closeButton = root.querySelector('[data-geo-close]');

      log('info', 'Setup started.', {
        sectionId: sectionId,
        visitorCountry: visitorCountry,
        currentHost: currentHost,
        testMode: testMode
      });

      if (!rulesElement || !dialog || !heading || !message || !switchLink || !stayButton || !closeButton) {
        log('warn', 'Missing required popup elements.', {
          hasRulesElement: Boolean(rulesElement),
          hasDialog: Boolean(dialog),
          hasHeading: Boolean(heading),
          hasMessage: Boolean(message),
          hasSwitchLink: Boolean(switchLink),
          hasStayButton: Boolean(stayButton),
          hasCloseButton: Boolean(closeButton)
        });
        return;
      }

      var parsed;
      try {
        parsed = JSON.parse(rulesElement.textContent);
      } catch (error) {
        log('error', 'Failed to parse rules JSON.', error);
        return;
      }

      var rules = parsed && Array.isArray(parsed.rules) ? parsed.rules : [];
      log('info', 'Rules loaded.', rules);

      if (!visitorCountry) {
        log('warn', 'Visitor country is empty. No country rule can match.');
      }

      rules.forEach(function (rule, index) {
        var sourceHost = normalizeHost(rule.source_host);
        var country = String(rule.country || '').toUpperCase();
        log('info', 'Evaluating rule.', {
          ruleIndex: index,
          ruleCountry: country,
          ruleSourceHost: sourceHost,
          countryMatches: country === visitorCountry,
          hostMatches: sourceHost === currentHost
        });
      });

      var activeRule = rules.find(function (rule) {
        var sourceHost = normalizeHost(rule.source_host);
        var country = String(rule.country || '').toUpperCase();
        return Boolean(country && sourceHost && country === visitorCountry && sourceHost === currentHost);
      });

      if (!activeRule) {
        log('warn', 'No matching rule found. Popup will not show.');
        return;
      }

      log('info', 'Matched rule.', activeRule);

      var dismissKey = getDismissKey(sectionId, activeRule);
      var storage = getStorage();

      if (!testMode && storage && storage.getItem(dismissKey) === '1') {
        log('info', 'Popup previously dismissed this session.', { dismissKey: dismissKey });
        return;
      }

      var targetHost = normalizeHost(activeRule.target_host);
      if (!targetHost) {
        log('warn', 'Matched rule is missing target host.', activeRule);
        return;
      }

      var cleanParams = new URLSearchParams(window.location.search);
      cleanParams.delete('geo_country');
      var searchString = cleanParams.toString() ? '?' + cleanParams.toString() : '';
      var targetUrl = window.location.protocol + '//' + targetHost + window.location.pathname + searchString + window.location.hash;

      heading.textContent = activeRule.heading || '';
      message.textContent = activeRule.message || '';
      switchLink.textContent = activeRule.switch_label || '';
      stayButton.textContent = activeRule.stay_label || '';
      switchLink.href = targetUrl;

      function dismiss() {
        if (!testMode && storage) {
          storage.setItem(dismissKey, '1');
        }
        log('info', 'Popup dismissed.', { dismissKey: dismissKey, testMode: testMode });
        dialog.style.display = 'none';
      }

      closeButton.addEventListener('click', dismiss);
      stayButton.addEventListener('click', dismiss);

      document.addEventListener('keydown', function onKeyDown(e) {
        if (e.key === 'Escape' && dialog.style.display !== 'none') {
          dismiss();
          document.removeEventListener('keydown', onKeyDown);
        }
      });

      switchLink.addEventListener('click', function () {
        if (!testMode && storage) {
          storage.setItem(dismissKey, '1');
        }
        log('info', 'Switch button clicked.', { targetUrl: targetUrl });
      });

      log('info', 'Opening popup.', { targetUrl: targetUrl });
      dialog.style.display = 'block';
    }

    function setup(root) {
      if (!root || root.dataset.enabled !== 'true') {
        log('info', 'Section skipped because popup is disabled.');
        return;
      }

      var sectionId = root.id.replace('GeoDomainSwitch-', '');
      var currentHost = normalizeHost(root.dataset.currentHost || window.location.hostname);
      var testMode = root.dataset.testMode === 'true';
      var params = new URLSearchParams(window.location.search);
      var queryCountryOverride = String(params.get('geo_country') || '').toUpperCase();

      if (queryCountryOverride) {
        log('info', 'Country override applied from query param.', { geo_country: queryCountryOverride });
        run(root, sectionId, queryCountryOverride, currentHost, testMode);
        return;
      }

      fetch('https://ipapi.co/json/')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var visitorCountry = String(data.country_code || '').toUpperCase();
          log('info', 'Country resolved from ipapi.co', { visitorCountry: visitorCountry });
          run(root, sectionId, visitorCountry, currentHost, testMode);
        })
        .catch(function () {
          var visitorCountry = String(root.dataset.visitorCountry || '').toUpperCase();
          log('warn', 'ipapi.co failed, falling back to Shopify country.', { visitorCountry: visitorCountry });
          run(root, sectionId, visitorCountry, currentHost, testMode);
        });
    }

    var roots;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        roots = document.querySelectorAll('.geo-domain-switch');
        log('info', 'DOMContentLoaded, initializing sections.', { sectionCount: roots.length });
        roots.forEach(setup);
      });
      return;
    }

    roots = document.querySelectorAll('.geo-domain-switch');
    log('info', 'Document already loaded, initializing sections.', { sectionCount: roots.length });
    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page-search"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('faq-page-search')) {
  customElements.define('faq-page-search', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.groups = [];
      this.input = this.querySelector('[data-page-search-input]');
      this.status = this.querySelector('[data-page-search-status]');
      this.scope = this.closest('main, [role="main"]') || this.closest('.shopify-section')?.parentElement;
      if (!this.scope || !this.input || !this.status) return;
      this.input.addEventListener('input', event => {
        if (!event.isComposing) this.update();
      }, options);
      this.input.addEventListener('compositionend', () => this.update(), options);
      this.querySelector('[data-page-search-clear]').addEventListener('click', () => {
        this.input.value = '';
        this.update();
        this.input.focus();
      }, options);
      const refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.discover());
      };
      document.addEventListener('DOMContentLoaded', refresh, options);
      document.addEventListener('shopify:section:load', refresh, options);
      document.addEventListener('shopify:section:unload', refresh, options);
      document.addEventListener('shopify:section:reorder', refresh, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.groups.some(group => group.element.contains(event.target))) return;
        this.input.value = '';
        queueMicrotask(() => { if (this.isConnected) this.update(); });
      }, options);
      refresh();
    }
    nodes(root) {
      const nodes = [];
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('script, style, template, noscript, svg, [aria-hidden="true"]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      while (walker.nextNode()) nodes.push(walker.currentNode);
      return nodes;
    }
    clearMarks(root) {
      root.querySelectorAll('mark[data-faq-page-mark]').forEach(mark => {
        const parent = mark.parentNode;
        mark.replaceWith(...mark.childNodes);
        parent.normalize();
      });
    }
    release() {
      this.groups.forEach(group => {
        group.element.removeAttribute('data-faq-page-hidden');
        group.items.forEach(item => {
          item.element.removeAttribute('data-faq-page-hidden');
          item.roots.forEach(root => this.clearMarks(root));
        });
      });
    }
    discover() {
      if (!this.isConnected) return;
      this.release();
      this.groups = [];
      this.scope.querySelectorAll('[data-faq-group]').forEach(root => {
        if (root.closest('nav, [role="navigation"], footer') || root.closest('header:not(.section-header)')) return;
        const section = root.closest('.shopify-section') || root;
        if (section.contains(this)) return;
        const items = [];
        root.querySelectorAll('[data-faq-item]').forEach(element => {
          if (element.closest('[data-faq-group]') !== root) return;
          const question = element.querySelector('[data-faq-question]');
          const answer = element.querySelector('[data-faq-answer]');
          if (question && answer) items.push({ element, roots: [question, answer] });
        });
        if (items.length) this.groups.push({ element: section, items });
      });
      const ids = this.groups.map(group => group.element.id).filter(Boolean);
      if (ids.length) this.input.setAttribute('aria-controls', ids.join(' '));
      else this.input.removeAttribute('aria-controls');
      this.hidden = this.groups.length === 0;
      this.update();
    }
    highlight(root, pattern) {
      const nodes = this.nodes(root);
      const text = nodes.map(node => node.data).join('');
      const ranges = Array.from(text.matchAll(pattern), match => [match.index, match.index + match[0].length]);
      let offset = 0;
      nodes.forEach(node => {
        const start = offset;
        offset += node.length;
        const overlaps = ranges.filter(([a, b]) => a < offset && b > start);
        if (!overlaps.length) return;
        const fragment = document.createDocumentFragment();
        let cursor = 0;
        overlaps.forEach(([a, b]) => {
          const from = Math.max(0, a - start);
          const to = Math.min(node.length, b - start);
          fragment.append(document.createTextNode(node.data.slice(cursor, from)));
          const mark = document.createElement('mark');
          mark.dataset.faqPageMark = '';
          mark.textContent = node.data.slice(from, to);
          fragment.append(mark);
          cursor = to;
        });
        fragment.append(document.createTextNode(node.data.slice(cursor)));
        node.replaceWith(fragment);
      });
    }
    update() {
      const terms = [...new Set(this.input.value.trim().split(/\s+/u).filter(Boolean))];
      const escapePattern = term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const tests = terms.map(term => new RegExp(escapePattern(term), 'iu'));
      const pattern = terms.length ? new RegExp(terms.sort((a, b) => b.length - a.length).map(escapePattern).join('|'), 'giu') : null;
      let count = 0;
      this.groups.forEach(group => {
        let groupCount = 0;
        group.items.forEach(item => {
          item.roots.forEach(root => this.clearMarks(root));
          const text = item.roots.map(root => this.nodes(root).map(node => node.data).join('')).join('\n');
          const matches = tests.every(test => test.test(text));
          item.element.toggleAttribute('data-faq-page-hidden', !matches);
          if (!matches) return;
          count++;
          groupCount++;
          if (pattern) item.roots.forEach(root => this.highlight(root, pattern));
        });
        group.element.toggleAttribute('data-faq-page-hidden', Boolean(terms.length) && groupCount === 0);
      });
      this.status.textContent = !terms.length ? '' : count ? this.status.dataset.count.replace('__COUNT__', String(count)) : this.status.dataset.empty;
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.release();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('faq-live-search')) {
  customElements.define('faq-live-search', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const input = this.querySelector('[data-faq-input]');
        if (!input) return;
        this.controller = new AbortController();
        const status = this.querySelector('[data-faq-status]');
        const items = Array.from(this.querySelectorAll('[data-faq-item]'));
        const regions = item => Array.from(item.querySelectorAll('[data-faq-question], [data-faq-answer]'));
        const textNodes = root => {
          const nodes = [];
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
            acceptNode: node => node.parentElement.closest('script, style, template, noscript') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
          });
          while (walker.nextNode()) nodes.push(walker.currentNode);
          return nodes;
        };
        const clear = root => {
          root.querySelectorAll('mark[data-faq-mark]').forEach(mark => {
            const parent = mark.parentNode;
            mark.replaceWith(...mark.childNodes);
            parent.normalize();
          });
        };
        const highlight = (root, pattern) => {
          const nodes = textNodes(root);
          const text = nodes.map(node => node.data).join('');
          const ranges = Array.from(text.matchAll(pattern), match => [match.index, match.index + match[0].length]);
          let offset = 0;
          nodes.forEach(node => {
            const start = offset;
            offset += node.length;
            const overlaps = ranges.filter(([a, b]) => a < offset && b > start);
            if (!overlaps.length) return;
            const fragment = document.createDocumentFragment();
            let cursor = 0;
            overlaps.forEach(([a, b]) => {
              const from = Math.max(0, a - start);
              const to = Math.min(node.length, b - start);
              fragment.append(document.createTextNode(node.data.slice(cursor, from)));
              const mark = document.createElement('mark');
              mark.dataset.faqMark = '';
              mark.textContent = node.data.slice(from, to);
              fragment.append(mark);
              cursor = to;
            });
            fragment.append(document.createTextNode(node.data.slice(cursor)));
            node.replaceWith(fragment);
          });
        };
        const update = () => {
          const terms = [...new Set(input.value.trim().split(/\s+/u).filter(Boolean))];
          const escapePattern = term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const patterns = terms.map(term => new RegExp(escapePattern(term), 'iu'));
          const pattern = terms.length ? new RegExp(terms.sort((a, b) => b.length - a.length).map(escapePattern).join('|'), 'giu') : null;
          let count = 0;
          items.forEach(item => {
            const roots = regions(item);
            roots.forEach(clear);
            const text = roots.map(root => textNodes(root).map(node => node.data).join('')).join('\n');
            const matches = patterns.every(test => test.test(text));
            item.hidden = !matches;
            if (matches) {
              count++;
              if (pattern) roots.forEach(root => highlight(root, pattern));
            }
          });
          status.textContent = !terms.length ? '' : count ? status.dataset.countTemplate.replace('__COUNT__', String(count)) : status.dataset.empty;
        };
        input.addEventListener('input', event => { if (!event.isComposing) update(); }, { signal: this.controller.signal });
        input.addEventListener('compositionend', update, { signal: this.controller.signal });
        this.addEventListener('shopify:block:select', () => { input.value = ''; update(); }, { signal: this.controller.signal });
        this.querySelector('[data-faq-controls]').hidden = false;
        update();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
